import { scriptsLoader } from '@pulse-web-platform-core/scripts-loader';
import { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './assets/css/index.css';

function renderApp(isAdBlockActive = false) {
  const App = lazy(() => import('./app'));
  const root = ReactDOM.createRoot(
    document.getElementById('pulseRoot') as HTMLElement
  );
  root.render(
    <Suspense fallback={null}>
      <App isAdBlockActive={isAdBlockActive} />
    </Suspense>
  );
}

scriptsLoader((hasError) => renderApp(hasError), [], false);
